// extracted by mini-css-extract-plugin
module.exports = {"container":"partners_container__0CPf7","heading":"partners_heading__Ot2ff","slides":"partners_slides__LFQFg","slide":"partners_slide__99baA"};